export const GRAVITY = 9.81;

// P = rho*g*h in kPa. Exact inverse of convertkPaToM (which additionally rounds for display).
// Kept dependency-free so the pressure walk (PCRoute) and the segment maths (PCSpool) can share it
// without pulling the unit-display modules into an import cycle.
export const headMetresToKpa = (headMetres: number, density: number): number => (density * GRAVITY * headMetres) / 1000;
